import { render } from "./Helpcenter.vue?vue&type=template&id=2474d09c"
import script from "./Helpcenter.vue?vue&type=script&lang=js"
export * from "./Helpcenter.vue?vue&type=script&lang=js"

import "./Helpcenter.vue?vue&type=style&index=0&id=2474d09c&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__